module.exports = __webpack_public_path__ + "media/images/career_camp/2023/mountains_2-fa24c5f166aa4f671ab2e1c66c35fa01.png";